<template>
  <div>
    <v-row>
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            v-model="nome"
            id="titulo-simulacao-baixas"
            class="my-0"
            label="Título*"
            outlined
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="origemBase !== 'ARQUIVO' ? 8 : 12">
        <validation-provider v-slot="{ errors }" rules="required" id="simulacao-baixas-origem-ais">
          <v-select
            v-model="origemBase"
            label="Origem da Base*"
            :items="origemBaseList"
            item-value="value"
            item-text="text"
            persistent-hint
            outlined
            :error-messages="errors"
            @change="clearInputsArquivoAis()"
          />
        </validation-provider>
      </v-col>
      <v-col cols="4" v-if="origemBase === 'AIS'">
        <date-picker
          v-model="database"
          label="Database AIS*"
          type="month"
          rules="required|min:10"
          hint="Informe uma data base de um AIS importado"
          persistent-hint
          outlined
        />
      </v-col>
      <v-col cols="4" v-else-if="origemBase === 'LAUDO_BLINDADO'">
        <date-picker
          v-model="database"
          label="Database Laudo Blindado*"
          type="month"
          rules="required|min:10"
          hint="Informe uma data base de um Laudo Blindado importado"
          persistent-hint
          outlined
        />
      </v-col>
    </v-row>
    <v-divider class="mt-n2 mb-4" />
    <v-row>
      <v-col :cols="$vuetify.breakpoint.xs ? 12 : 6" v-if="origemBase === 'ARQUIVO'" class="d-inline-flex">
        <v-sheet elevation="2"  width="100%">
          <mapeamento-arquivo
            ref="refMapeamentoArquivoAIS"
            class="mt-0 pt-0"
            fileInputLabel="Arquivo do AIS"
            :camposMapeamento="arquivoAis.mapeamento"
            :camposObrigatorios="arquivoAis.camposObrigatorios"
            :preloadItems="($route.params.id && arquivoAis.id) ? true : false"
            :functionDownloadArquivoModelo="() => downloadArquivoModeloAIS()"
            :loadingArquivoModelo="loadingnDownloadArquivoModeloAIS"
            @change="arquivoAis = $event"
            @preLoadingItemsReleased="fillFieldsArquivoAis()"
            @clearActionTriggered="clearInputsArquivoAis()"
          />
        </v-sheet>
      </v-col>
      <v-col :cols="(origemBase === 'ARQUIVO' && !$vuetify.breakpoint.xs) ? 6 : 12">
        <v-sheet elevation="2" width="100%">
          <v-row style="display: contents !important">
            <v-col cols="12" class="pa-0 pt-3">
              <v-alert dense outlined type="info" color="blue" class="mx-3" id="simulacao-baixas-v-alert">
                <div>
                  <a href="javascript:void(0)" @click="getArquivoModelo()">Clique aqui</a> para baixar o modelo para a importação.
                  <br>OBS: O arquivo deve conter as seguintes colunas: <b>{{cabecalhoArquivoBaixas.join(', ')}}</b> (exatamente nessa ordem e com esses nomes).
                  <br>OBS²: O arquivo enviado precisa estar no formato <b>UTF-8</b>.
                  <br><b style="color: #cc0000 !important">OBS³: As colunas (IMOBILIZADO, SUBNUMERO, IDUC) são opcionais, estas e quaisquer outras colunas que queira desconsiderar basta deixar os valores em branco</b>.
                </div>
              </v-alert>
            </v-col>
          </v-row>
          <div id="simulacao-baixas-campos-arquivo">
            <v-row style="display: contents !important">
              <v-col cols="12" class="pa-0 pr-3">
                <validation-provider v-slot="{ errors }" rules="required" class="mx-10">
                  <v-file-input
                    v-model="arquivoBaixasFileObj"
                    label="Arquivo de Baixas"
                    placeholder="Selecione um arquivo CSV"
                    outlined
                    accept=".csv, .zip"
                    truncate-length="30"
                    :loading="arquivoBaixasUploading"
                    loader-height="4"
                    :success="arquivoBaixasId && arquivoBaixasFileObj ? true : false"
                    :error-messages="errors"
                    @change="uploadNewFile($event)"
                    @click:clear="clearInputsArquivoBaixas()"
                  />
                </validation-provider>
                <validation-provider rules="required">
                  <input type="hidden" name="validate-upload-arquivo-baias" :value="arquivoBaixasId" />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row style="display: contents !important">
              <v-col cols="12" class="pa-0">
                <parametros-arquivo-csv
                  :delimitador.sync="arquivoBaixasDelimitador"
                  :involucro.sync="arquivoBaixasInvolucro"
                  :escape.sync="arquivoBaixasEscape"
                />
              </v-col>
            </v-row>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-divider class="mt-5 mb-5" />
    <v-row>
      <v-col cols="12">
        <general-editar-rodadas
          id="painel-rodadas"
          :rodadas.sync="rodadasLocal"
          :atributosRodadas="atributosRodadas"
          :panels.sync="panels"
        />
      </v-col>
    </v-row>
    <v-divider class="mt-0 mb-3" />
    <v-row align="center">
      <v-col cols="6">
        <v-checkbox
          v-model="somenteUarPrincipal"
          id="simulacao-baixas-somente-uar-principal"
          label="Somente UAR Principal?"
        />
      </v-col>
      <v-col cols="6">
        <div class="d-flex mx-auto">
          <v-checkbox
            v-model="atributosCoringa"
            id="simulacao-baixas-atributos-coringa"
            label="Habilitar Atributos Coringa?"
          />
          <div class="ml-1" style="align-self: center !important">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  id="simulacao-baixas-atributos-coringa-help"
                  @click="dialogAtributosCoringa = true"
                >
                  mdi-progress-question
                </v-icon>
              </template>
              <span>Clique aqui para obter um informativo sobre habilitar atributos coringa</span>
            </v-tooltip>
          </div>
        </div>
      </v-col>
    </v-row>
    <dialog-atributos-coringa :activated.sync="dialogAtributosCoringa" />
  </div>
</template>

<script>
import SimulacaoBaixasService from '@/services/SimulacaoBaixasService';
import ArquivosService from '@/services/ArquivosService';
import randomString from "@/utils/generateRandomString";

export default {
  components: {
    DatePicker:             () => import("@/components/general/DatePicker.vue"),
    ParametrosArquivoCsv:   () => import("@/components/general/GeneralParametrosArquivoCsv.vue"),
    MapeamentoArquivo:      () => import("@/components/general/GeneralMapeamentoArquivo.vue"),
    GeneralEditarRodadas:   () => import("@/components/general/GeneralEditarRodadas.vue"),
    DialogAtributosCoringa: () => import("@/components/simuladorBaixas/DialogAtributosCoringa.vue")
  },

  mounted() {
    this.rodadasLocal = this.rodadas;
  },

  data: () => ({
    dialogAtributosCoringa: false,
    panels: undefined,
    rodadasLocal: [
      { key: randomString(30), valores: ["ODI", "TI", "TUC", "A1", "A2", "A3", "A4", "A5", "A6", "UAR"] },
      { key: randomString(30), valores: ["ODI", "TI", "TUC", "A1", "A2", "A3", "A4", "A5", "A6"] },
      { key: randomString(30), valores: ["TUC", "A1", "A2", "A3", "A4", "A5", "A6"] },
      { key: randomString(30), valores: ["ODI", "TI", "TUC", "A1"] },
      { key: randomString(30), valores: ["ODI", "TI", "TUC"] },
      { key: randomString(30), valores: ["TUC"] }
    ],
    cabecalhoArquivoBaixas: [
      'ID',
      'IMOBILIZADO',
      'SUBNUMERO',
      'IDUC',
      'ODI',
      'TI',
      'TUC',
      'A1',
      'A2',
      'A3',
      'A4',
      'A5',
      'A6',
      'UAR',
      'QTD'
    ],
    loadingnDownloadArquivoModeloAIS: false
  }),

  computed: {
    nome: {
      get () { return this.$store.state.simuladorBaixas.nome},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'nome': value})}
    },
    origemBase: {
      get () { return this.$store.state.simuladorBaixas.origemBase},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'origemBase': value})}
    },
    origemBaseList: {
      get () { return this.$store.state.simuladorBaixas.origemBaseList}
    },
    database: {
      get () { return this.$store.state.simuladorBaixas.dataBase},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'dataBase': value})}
    },
    arquivoAis: {
      get () { return this.$store.state.simuladorBaixas.arquivoAis},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'arquivoAis': value})}
    },
    arquivoBaixasId: {
      get () { return this.$store.state.simuladorBaixas.arquivoBaixas.id},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'arquivoBaixas': {'id': value}})}
    },
    arquivoBaixasFileObj: {
      get () { return this.$store.state.simuladorBaixas.arquivoBaixas.fileObj},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'arquivoBaixas': {'fileObj': value}})}
    },
    arquivoBaixasUploading: {
      get () { return this.$store.state.simuladorBaixas.arquivoBaixas.uploading},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'arquivoBaixas': {'uploading': value}})}
    },
    arquivoBaixasDelimitador: {
      get () { return this.$store.state.simuladorBaixas.arquivoBaixas.delimitador},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'arquivoBaixas': {'delimitador': value}})}
    },
    arquivoBaixasInvolucro: {
      get () { return this.$store.state.simuladorBaixas.arquivoBaixas.involucro},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'arquivoBaixas': {'involucro': value}})}
    },
    arquivoBaixasEscape: {
      get () { return this.$store.state.simuladorBaixas.arquivoBaixas.escape},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'arquivoBaixas': {'escape': value}})}
    },
    arquivoBaixasFakeFile: {
      get () { return this.$store.state.simuladorBaixas.arquivoBaixas.fakeFile},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'arquivoBaixas': {'fakeFile': value}})}
    },
    arquivoBaixasHeaderValido: {
      get () { return this.$store.state.blindadaMovimentacao.arquivoBaixas.headerValido},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'arquivoBaixas': {'headerValido': value}})}
    },
    somenteUarPrincipal: {
      get () { return this.$store.state.simuladorBaixas.somenteUarPrincipal},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'somenteUarPrincipal': value})}
    },
    atributosCoringa: {
      get () { return this.$store.state.simuladorBaixas.atributosCoringa},
      set (value) { this.$store.dispatch('setSimulacaoBaixas', {'atributosCoringa': value})}
    },
    atributosRodadas: {
      get () { return this.$store.state.simuladorBaixas.atributosRodadas}
    },
    rodadas: {
      get () { return this.$store.state.simuladorBaixas.rodadas},
      set (value) { this.$store.dispatch('setSimulacaoBaixasRodadas', value)}
    }
  },

  methods:{
    fillFieldsArquivoAis() {
      if (this.origemBase == 'ARQUIVO' && this.$route.params.id) {
        const item = this.arquivoAis;

        this.$refs.refMapeamentoArquivoAIS.fillFieldsCsv(
          item.id,
          item.delimitador,
          item.involucro,
          item.escape,
          item.mapeamento
        );
      }
    },

    clearInputsArquivoAis() {
      this.database = null;
      this.arquivoAis = {
        id: null, 
        delimitador: null, 
        involucro: null, 
        escape: null,
        mapeamento: {"IMOBILIZADO": "", "SUBNUMERO": "", "IDUC": "", "DATA_IMOBILIZACAO": "", "ODI": "", "TI": "", "TUC": "", "A1": "", "A2": "", "A3": "", "A4": "", "A5": "", "A6": "", "UAR": "", "UAR_PRINCIPAL": "", "QTD": "", "VOC": "", "DEP_VOC": ""}
      };
      
      if (this.$refs.refMapeamentoArquivoAIS) {
        this.$refs.refMapeamentoArquivoAIS.clearComponentData(this.arquivoAis.mapeamento);
      }
      this.$forceUpdate();
    },

    clearInputsArquivoBaixas() {
      this.arquivoBaixasId = "";
      this.arquivoBaixasFileObj = null;
      this.arquivoBaixasDelimitador = ";";
      this.arquivoBaixasInvolucro = `"`;
      this.arquivoBaixasEscape = `"`;
      this.arquivoBaixasFakeFile = false;
      this.arquivoBaixasHeaderValido = false;

      this.$forceUpdate();
    },

    uploadNewFile(arquivo) {
      if (!arquivo) {
        this.clearInputsArquivoBaixas();
        return true;
      }

      this.arquivoBaixasFakeFile = false;
      this.arquivoBaixasId = "";
      this.arquivoBaixasUploading = true;
      
      let formDataWithFile = new FormData();
      formDataWithFile.append("file", arquivo);

      ArquivosService.uploadFile(formDataWithFile)
        .then(async response => {
          await this.validaHeader(
            response.data.arquivoId,
            this.arquivoBaixasDelimitador,
            this.arquivoBaixasInvolucro,
            this.arquivoBaixasEscape,
            this.cabecalhoArquivoBaixas
          );
          this.arquivoBaixasId = response.data.arquivoId;
        })
        .catch((err) => {
          if (err?.data?.error_code == 120 || err?.data?.error_code == 121) {
            this.$toast.error(err.data.erro, "", { position: "topRight", timeout: 6000 });
          } else {
            this.$toast.error("Erro no upload do arquivo.", "", { position: "topRight" });
            console.error("Erro ao fazer upload: ", err);
          }

          this.clearInputsArquivoBaixas();
        })
        .finally(() => this.arquivoBaixasUploading = false);
    },

    validaHeader(arquivoId, delimitador, involucro, escape, cabecalhoEsperado) {
      return ArquivosService.validarHeaderCSV(arquivoId, { delimitador, involucro, escape, cabecalhoEsperado })
        .catch(err => { throw err });
    },

    getArquivoModelo() {
      this.$toast.info("Processando...", "", { position: "topRight", timeout: 1250 });
      SimulacaoBaixasService.baixarArquivoModeloBaixas()
        .then(async res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", `arquivo_modelo_baixas.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          this.$toast.error("Erro ao baixar arquivo modelo do sistema", "", { position: "topRight"});
          console.error(err);
        })
    },

    downloadArquivoModeloAIS() {
      this.loadingnDownloadArquivoModeloAIS = true;

      SimulacaoBaixasService.baixarArquivoModeloAIS()
        .then(async res => {
          this.$toast.info("Processando...", "", { position: "topRight", timeout: 1500 });

          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `arquivo_modelo_ais.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          this.$toast.error("Erro ao baixar arquivo modelo do AIS", "", { position: "topRight"});
          console.error(err);
        })
        .finally(() => this.loadingnDownloadArquivoModeloAIS = false);
    },

    exportData() {
      const vuexData = this.$store.state.simuladorBaixas;

      return {
        id: this.$route.params.id ? this.$route.params.id : null,
        nome: vuexData.nome,
        data_base: vuexData.origemBase !== 'ARQUIVO' ? vuexData.dataBase : null,
        somente_uar_principal: vuexData.somenteUarPrincipal,
        atributos_coringa: vuexData.atributosCoringa,
        arquivo_id: vuexData.arquivoBaixas.id,
        arquivo_delimitador: vuexData.arquivoBaixas.delimitador,
        arquivo_involucro: vuexData.arquivoBaixas.involucro,
        arquivo_escape: vuexData.arquivoBaixas.escape,
        origem_ais: vuexData.origemBase,
        arquivo_ais_id: vuexData.origemBase == 'ARQUIVO' ? vuexData.arquivoAis.id : null,
        arquivo_ais_delimitador: vuexData.origemBase == 'ARQUIVO' ? vuexData.arquivoAis.delimitador : null,
        arquivo_ais_involucro: vuexData.origemBase == 'ARQUIVO' ? vuexData.arquivoAis.involucro : null,
        arquivo_ais_escape: vuexData.origemBase == 'ARQUIVO' ? vuexData.arquivoAis.escape : null,
        mapeamento_arquivo_ais: vuexData.origemBase == 'ARQUIVO' ? vuexData.arquivoAis.mapeamento : null,
        rodadas: vuexData.rodadas
      };
    }
  },

  watch: {
    rodadasLocal: {
      handler(newValue) {
        this.rodadas = newValue;
      },
      deep:true
    }
  }
}
</script>